import Login from '@components/Login/Login'

const LoginPage = ({ pageData }) => <Login pageData={pageData} />

LoginPage.getInitialProps = async (ctx, pageData) => {
  return { pageData }
}

export default LoginPage
